import React from "react";
import TTSelect from "./TTSelect/TTSelect";

export default function TtSelectArray(props) {
  const { component, currentConfig, handleChangeArray, toIntIf, values } =
    props;

  const LeftArray = Array(component.items)
    .fill()
    .map(
      (i, k) =>
        k % 2 == 0 && (
          <TTSelect
            key={`SelectArr${k}`}
            component={component}
            placeholder={`Seleziona ...`}
            options={component.permittedValues.map((v, k) => {
              if (typeof v === "object" && v !== null) {
                return {
                  ...v,
                  text: v.description,
                  value: v.code,
                  id: k,
                  img: `${process.env.REACT_APP_IMAGE_PATH}${v.file}.png`,
                };
              }
              return { text: v, value: v, id: k };
            })}
            currentConfig={currentConfig}
            toIntIf={toIntIf}
            onChange={(value) => {
              handleChangeArray(component, component.name, k, value);
            }}
            value={values[component.name]?.data[k] || null}
          />
        )
    );
  const RightArray = Array(component.items)
    .fill()
    .map(
      (i, k) =>
        k % 2 != 0 && (
          <TTSelect
            key={`SelectArr${k}`}
            component={component}
            placeholder={`Seleziona ...`}
            options={component.permittedValues.map((v, k) => {
              if (typeof v === "object" && v !== null) {
                return {
                  ...v,
                  text: v.description,
                  value: v.code,
                  id: k,
                  img: v.file
                    ? `${process.env.REACT_APP_IMAGE_PATH}${v.file}.png`
                    : false,
                };
              }
              return { text: v, value: v, id: k };
            })}
            currentConfig={currentConfig}
            toIntIf={toIntIf}
            onChange={(value) => {
              handleChangeArray(component, component.name, k, value);
            }}
            value={values[component.name]?.data[k] || null}
          />
        )
    );
  return (
    <>
      <label>Sinistra:</label>
      {LeftArray}
      <label>Destra:</label>
      {RightArray}
    </>
  );
}
